import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StateNotifyService } from '../../../../common/state/service/state-notify.service';
import { Trail } from '../../dto/trail';
import { TrailService } from '../../service/trail.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'dpi-trail-list',
  imports: [MatCardModule, MatTableModule, MatIconModule, MatButtonModule, MatToolbarModule, MatTooltipModule, NgIf],
  templateUrl: './trail-list.component.html',
  styleUrl: './trail-list.component.scss'
})
export class TrailListComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['name', 'office', 'start_date', 'end_date'];
  dataSource: Trail[] = [];
  destroyed$ = new Subject<void>(); // notifier of component being destroyed
  @Output('listSizeChanged') listSize = new EventEmitter<number>();
  isReadonly: boolean;

  constructor(private trailService: TrailService, private notifyService: StateNotifyService, private router: Router) {
    this.isReadonly = true;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.notifyService.vesselSelection$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(model => {
        this.reloadTrailList(model.id)
      })

    this.notifyService.readonlyMode$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.isReadonly = res;
      });
  }

  reloadTrailList(vesselId: number) {
    this.trailService.getAllTrialsOfVessel(vesselId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: res => {
          this.dataSource = res;
          this.notifyService.updateListAllTrails(this.dataSource); // for the list of all trails in SideNav
          this.listSize.emit(this.dataSource.length);
        },
        error: err => { console.log(err); this.dataSource = []; }
      });
  }

  selectTrail(selected: Trail) {
    this.notifyService.updateTrailSelection(selected); // for the trail's details and other features
    this.router.navigate(['trail-hub']);
  }

  createTrail() {
    let vesselModel = this.notifyService.getSelectedVessel();
    this.trailService.createTrial(vesselModel.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: model => {
          this.dataSource.push(model);
          this.selectTrail(model);
        },
        error: err => { console.log(err); }
      });
  }

}
